module.exports = __webpack_public_path__ + "static/media/side-login.4d3fd666.png";